function BaseUrl() {
  return process.env.REACT_APP_API_URL;
}

export default BaseUrl;
